import { fetchAlldemoCategoriesApi, createDemoCategoryApi, deleteCategoryApi, getAllDemoQuestionByCategoryApi,
        updateDemoCategoryApi, addDemographicsQuestionApi, softDeleteCategoryQuestionApi, getAlloptionsByQuestionApi,
        updateQuestionDemographicsApi, addOptionByQuestionApi, updateOptionByQuestionApi, softDeleteOptionApi,
        getSubQuestionListApi, insertSubQuestionApi , softDeleteSubQuestionApi, getSubQuesDataByIdApi, updatesubQuestionApi,
        getSubQuesOptionsByIdApi, softDeleteSubOptionApi, addSubOptionBySubQuestionApi, getSubOptionDataByOptionIdApi,
        UpdateSubOptionApi, getSecSubQuestionListApi, insertSecSubQuestionApi, getSecSubQuesDataByIdApi, updateSecSubQuestionApi,
        getSecSubQuesOptionsByIdApi, addSecSubOptionBySubQuestionApi, softDeleteSecSubOptionApi, softDeleteSecSubQuestionApi , 
        getSecSubOptionDataByOptionIdApi, UpdateSecSubOptionApi} from '../api/demographicsApi'

import {requestStarted,requestCompleted} from "./common"


export const setDemographicsCategories =(response) => {
  return {
    type : "SET_DEMO_CATEGORIES_LIST",
    response
  }
}

//setDemographicsCategoriesQuestions
export const setDemographicsCategoriesQuestions =(response) => {
  return {
    type : "SET_DEMO_CATEGORIES_QUESTIONS_LIST",
    response
  }
}

//setDemographicsAddCategoriesResSuccess
export const setDemographicsAddCategoriesResSuccess =(response) => {
  return {
    type : "SET_DEMO_ADD_CATEGORIES_SUCCESS",
    response
  }
}

export const setDemographicsAddCategoriesResFail =(response) => {
  return {
    type : "SET_DEMO_ADD_CATEGORIES_FAIL",
    response
  }
}

//emptyDemographicsCategories
export const emptyDemographicsCategories =() => {
  return {
    type : "SET_EMPTY_DEMO_ADD_CATEGORIES_RES", 
  }
}

//setDemographicsCategoriesUpdateSuccess
export const setDemographicsCategoriesUpdateSuccess =(response) => {
  return {
    type : "SET_DEMO_UPDATE_CATEGORIES_SUCCESS",
    response
  }
}

export const setDemographicsCategoriesUpdateFail =(response) => {
  return {
    type : "SET_DEMO_UPDATE_CATEGORIES_FAIL",
    response
  }
}

//setDemographicsQuestionAddSuccess

export const setDemographicsQuestionAddSuccess =(response) => {
  return {
    type : "SET_DEMO_ADD_QUESTIONS_SUCCESS",
    response
  }
}

//setDemographicsQuestionAddFail
export const setDemographicsQuestionAddFail =(response) => {
  return {
    type : "SET_DEMO_ADD_QUESTIONS_Fail",
    response
  }
}

//emptyDemoQuestionResponse
export const emptyDemoQuestionResponse =() => {
  return {
    type : "SET_EMPTY_DEMO_ADD_QUESTION_RES", 
  }
}

//setDemographicsQuestionsOptions
export const setDemographicsQuestionsOptions =(response) => {
  return {
    type : "SET_DEMO_CATEGORIES_QUESTIONS_OPTIONS_LIST",
    response
  }
}

export const setDemographicsQuestionUpdateSuccess =(response) => {
  return {
    type : "SET_DEMO_UPDATE_QUESTION_SUCCESS",
    response
  }
}

export const setDemographicsQuestionUpdateFail =(response) => {
  return {
    type : "SET_DEMO_UPDATE_QUESTION_FAIL",
    response
  }
}

//emptyDemographicsQuestions
export const emptyDemographicsQuestions =() => {
  return {
    type : "SET_EMPTY_DEMO_QUESTIONS_RESPONSE"
  }
}

//setDemographicsOptionAddSuccess
export const setDemographicsOptionAddSuccess =(response) => {
  return {
    type : "SET_DEMO_ADD_OPTIONS_SUCCESS",
    response
  }
}

//setDemographicsOptionAddFail
export const setDemographicsOptionAddFail =(response) => {
  return {
    type : "SET_DEMO_ADD_OPTIONS_Fail",
    response
  }
}

//emptyDemographicsOption
export const emptyDemographicsOption =() => {
  return {
    type : "SET_EMPTY_OPTION_RESPONSE"
  }
}
export const emptyDemographicsSubOption =() => {
  return {
    type : "SET_EMPTY_SUB_OPTION_RESPONSE"
  }
}
export const setDemographicsOptionUpdateSuccess =(response) => {
  return {
    type : "SET_DEMO_UPDATE_OPTION_SUCCESS",
    response
  }
}

export const setDemographicsOptionUpdateFail =(response) => {
  return {
    type : "SET_DEMO_UPDATE_OPTION_FAIL",
    response
  }
}

//setDemographicsCategoriesSubQuestions
export const setDemographicsCategoriesSubQuestions =(response) => {
  return {
    type : "SET_DEMO_CATEGORIES_SUB_QUESTIONS_LIST",
    response
  }
}

//setDemographicsSubQuestionAddSuccess
export const setDemographicsSubQuestionAddSuccess =(response) => {
  return {
    type : "SET_DEMO_ADD_SUB_QUESTIONS_SUCCESS",
    response
  }
}

//setDemographicsSubQuestionAddFail
export const setDemographicsSubQuestionAddFail =(response) => {
  return {
    type : "SET_DEMO_ADD_SUB_QUESTIONS_Fail",
    response
  }
}

// emptyDemoSubQuestionResponse
export const emptyDemoSubQuestionResponse =(response) => {
  return {
    type : "SET_EMPTY_SUB_QUESTION_RESPONSE",
    response
  }
}

export const setEditSubQuestions = (response) =>{
  return{
    type : "SET_EDIT_SUB_QUESTION_DATA",
    response
  }
}

export const setDemographicsSubQuestionUpdateSuccess =(response) => {
  return {
    type : "SET_DEMO_UPDATE_SUB_QUES_SUCCESS",
    response
  }
}

export const setDemographicsSubQuestionUpdateFail =(response) => {
  return {
    type : "SET_DEMO_UPDATE_SUB_QUES_FAIL",
    response
  }
}

//setSubOptionList
export const setSubOptionList =(response) => {
  return {
    type : "SET_SUB_OPTIONS_LIST",
    response
  }
}

//setDemoSubOptionAddSuccess
export const setDemoSubOptionAddSuccess =(response) => {
  return {
    type : "SET_DEMO_ADD_SUB_OPTION_SUCCESS",
    response
  }
}

//setDemoSubOptionAddFail
export const setDemoSubOptionAddFail =(response) => {
  return {
    type : "SET_DEMO_ADD_SUB_OPTION_FAIL",
    response
  }
}

//setSubOptionEditData
export const setSubOptionEditData =(response) => {
  return {
    type : "SET__SUB_OPTION_EDIT_DATA",
    response
  }
}

//setDemographicsSubOptionUpdateSuccess
export const setDemographicsSubOptionUpdateSuccess =(response) => {
  return {
    type : "SET_SUB_OPTION_UPDATE_SUCCESS_RES",
    response
  }
}

//setDemographicsSubOptionUpdateFail
export const setDemographicsSubOptionUpdateFail =(response) => {
  return {
    type : "SET_SUB_OPTION_UPDATE_FAIL_RES",
    response
  }
}

export const setDemographicsCategoriesSecSubQuestions =(response) => {
  return {
    type : "SET_DEMO_CATEGORIES_SEC_SUB_QUESTIONS_LIST",
    response
  }
}

//setDemographicsSubQuestionAddSuccess
export const setDemographicsSecSubQuestionAddSuccess =(response) => {
  return {
    type : "SET_DEMO_ADD_SEC_SUB_QUESTIONS_SUCCESS",
    response
  }
}

//setDemographicsSubQuestionAddFail
export const setDemographicsSecSubQuestionAddFail =(response) => {
  return {
    type : "SET_DEMO_ADD_SEC_SUB_QUESTIONS_Fail",
    response
  }
}

//emptyDemoSecSubQuestionResponse
export const emptyDemoSecSubQuestionResponse =(response) => {
  return {
    type : "SET_EMPTY_SEC_SUB_QUESTION_RESPONSE",
    response
  }
}

export const setEditSecSubQuestions = (response) =>{
  return{
    type : "SET_EDIT_SEC_SUB_QUESTION_DATA",
    response
  }
}

export const setDemographicsSecSubQuestionUpdateSuccess =(response) => {
  return {
    type : "SET_DEMO_UPDATE_SEC_SUB_QUES_SUCCESS",
    response
  }
}

export const setDemographicsSecSubQuestionUpdateFail =(response) => {
  return {
    type : "SET_DEMO_UPDATE_SEC_SUB_QUES_FAIL",
    response
  }
}

export const setSecSubOptionList =(response) => {
  return {
    type : "SET_SEC_SUB_OPTIONS_LIST",
    response
  }
}

export const setDemoSecSubOptionAddSuccess =(response) => {
  return {
    type : "SET_DEMO_ADD_SEC_SUB_OPTION_SUCCESS",
    response
  }
}

//setDemoSubOptionAddFail
export const setDemoSecSubOptionAddFail =(response) => {
  return {
    type : "SET_DEMO_ADD_SEC_SUB_OPTION_FAIL",
    response
  }
}

export const emptyDemographicsSecSubOption =() => {
  return {
    type : "SET_EMPTY_SEC_SUB_OPTION_RESPONSE"
  }
}

export const setSecSubOptionEditData =(response) => {
  return {
    type : "SET_SEC_SUB_OPTION_EDIT_DATA",
    response
  }
}


export const setDemographicsSecSubOptionUpdateSuccess =(response) => {
  return {
    type : "SET_SEC_SUB_OPTION_UPDATE_SUCCESS_RES",
    response
  }
}

export const setDemographicsSecSubOptionUpdateFail =(response) => {
  return {
    type : "SET_SEC_SUB_OPTION_UPDATE_FAIL_RES",
    response
  }
}

export const fetchAlldemoCategories=(token) =>{
  return dispatch =>{
    dispatch(requestStarted());
      fetchAlldemoCategoriesApi(token).then((result) =>{
    dispatch(requestCompleted());
        dispatch(setDemographicsCategories(result));
    });
  }
}



//createDemoCategory

export const createDemoCategory=(data) =>{
  return dispatch =>{
    dispatch(requestStarted());
    createDemoCategoryApi(data).then((result) =>{
    dispatch(requestCompleted());
      if(result.success){
        dispatch(setDemographicsAddCategoriesResSuccess(result));
      }else{
        dispatch(setDemographicsAddCategoriesResFail(result));
      }
    });
  }
}

//deleteCategory

export const deleteCategory=(data) =>{
  return dispatch =>{
    dispatch(requestStarted());
    deleteCategoryApi(data).then((result) =>{
    dispatch(requestCompleted());
      if(result.success){
        alert(result.message);
        dispatch(setDemographicsCategories(result));
      }else{
        alert(result.message);
      }
    });
  }
}

//getAllDemoQuestionByCategory
export const getAllDemoQuestionByCategory=(catId) =>{
  return dispatch =>{
    dispatch(requestStarted());
    getAllDemoQuestionByCategoryApi(catId).then((result) =>{
    dispatch(requestCompleted());
      if(result.success){
        dispatch(setDemographicsCategoriesQuestions(result));
      }else{
        alert(result.message);
      }
    });
  }
}

//updateDemoCategory

export const updateDemoCategory=(data) =>{
  return dispatch =>{
    dispatch(requestStarted());
    updateDemoCategoryApi(data).then((result) =>{
    dispatch(requestCompleted());
      if(result.success){
       dispatch(setDemographicsCategoriesUpdateSuccess(result));
      }else{
        dispatch(setDemographicsCategoriesUpdateFail(result));
      }
    });
  }
}

//addDemographicsQuestion

export const addDemographicsQuestion=(data) =>{
  return dispatch =>{
    dispatch(requestStarted());
    addDemographicsQuestionApi(data).then((result) =>{
    dispatch(requestCompleted());
      if(result.success){
       dispatch(setDemographicsQuestionAddSuccess(result));
      }else{
       dispatch(setDemographicsQuestionAddFail(result));
      }
    });
  }
}

//softDeleteCategoryQuestion

export const softDeleteCategoryQuestion=(data) =>{
  return dispatch =>{
    dispatch(requestStarted());
    softDeleteCategoryQuestionApi(data).then((result) =>{
    dispatch(requestCompleted());
      if(result.success){
        alert(result.message);
        dispatch(setDemographicsCategoriesQuestions(result));
      }else{
        alert(result.message);
      }
    });
  }
}

//getAlloptionsByQuestion
export const getAlloptionsByQuestion=(quesId) =>{
  return dispatch =>{
    dispatch(requestStarted());
    getAlloptionsByQuestionApi(quesId).then((result) =>{
    dispatch(requestCompleted());
      if(result.success){
        dispatch(setDemographicsQuestionsOptions(result));
      }else{
        alert(result.message);
      }
    });
  }
}

//updateQuestionDemographics
export const updateQuestionDemographics=(data) =>{
  return dispatch =>{
    dispatch(requestStarted());
    updateQuestionDemographicsApi(data).then((result) =>{
    dispatch(requestCompleted());
      if(result.success){
       dispatch(setDemographicsQuestionUpdateSuccess(result));
      }else{
       dispatch(setDemographicsQuestionUpdateFail(result));
      }
    });
  }
}

//addOptionByQuestion
export const addOptionByQuestion=(data) =>{
  return dispatch =>{
    dispatch(requestStarted());
    addOptionByQuestionApi(data).then((result) =>{
    dispatch(requestCompleted());
      if(result.success){
       dispatch(setDemographicsOptionAddSuccess(result));
      }else{
       dispatch(setDemographicsOptionAddFail(result));
      }
    });
  }
}

//updateOptionByQuestion
export const updateOptionByQuestion=(data) =>{
  return dispatch =>{
    dispatch(requestStarted());
    updateOptionByQuestionApi(data).then((result) =>{
    dispatch(requestCompleted());
      if(result.success){
       dispatch(setDemographicsOptionUpdateSuccess(result));
      }else{
       dispatch(setDemographicsOptionUpdateFail(result));
      }
    });
  }
}

//softDeleteOption
export const softDeleteOption=(data) =>{
  return dispatch =>{
    dispatch(requestStarted());
    softDeleteOptionApi(data).then((result) =>{
    dispatch(requestCompleted());
      if(result.success){
       
        dispatch(setDemographicsQuestionsOptions(result));
      }else{
        alert(result.message);
      }
    });
  }
}

//getSubQuestionList
export const getSubQuestionList=( catId, quesId) =>{
  return dispatch =>{
    dispatch(requestStarted());
    getSubQuestionListApi(catId, quesId).then((result) =>{
    dispatch(requestCompleted());
      if(result.success){
       dispatch(setDemographicsCategoriesSubQuestions(result));
     }else{
        alert(result.message);
     }
    });
  }
}

//insertSubQuestion
export const insertSubQuestion=(data) =>{
  return dispatch =>{
    dispatch(requestStarted());
    insertSubQuestionApi(data).then((result) =>{
    dispatch(requestCompleted());
      if(result.success){
       dispatch(setDemographicsSubQuestionAddSuccess(result));
      }else{
       dispatch(setDemographicsSubQuestionAddFail(result));
      }
    });
  }
}

//softDeleteSubQuestion
export const softDeleteSubQuestion=(data) =>{
  return dispatch =>{
    dispatch(requestStarted());
    softDeleteSubQuestionApi(data).then((result) =>{
    dispatch(requestCompleted());
      if(result.success){ 
        dispatch(setDemographicsCategoriesSubQuestions(result));
      }else{
        alert(result.message);
      }
    });
  }
}

//getSubQuesDataById
export const getSubQuesDataById=(id) =>{
  return dispatch =>{
    dispatch(requestStarted());
    getSubQuesDataByIdApi(id).then((result) =>{
    dispatch(requestCompleted());
      if(result.success){ 
      dispatch(setEditSubQuestions(result));
      }else{
        alert(result.message);
      }
    });
  }
}

//updatesubQuestion
export const updatesubQuestion=(data) =>{
  return dispatch =>{
    dispatch(requestStarted());
    updatesubQuestionApi(data).then((result) =>{
    dispatch(requestCompleted());
      if(result.success){
       dispatch(setDemographicsSubQuestionUpdateSuccess(result));
      }else{
       dispatch(setDemographicsSubQuestionUpdateFail(result));
      }
    });
  }
}

//getSubQuesOptionsById
export const getSubQuesOptionsById=(id) =>{
  return dispatch =>{
    dispatch(requestStarted());
    getSubQuesOptionsByIdApi(id).then((result) =>{
    dispatch(requestCompleted());
      if(result.success){ 
        dispatch(setSubOptionList(result));
      }else{
        alert(result.message);
      }
    });
  }
}

//softDeleteSubOption
export const softDeleteSubOption=(data) =>{
  return dispatch =>{
    dispatch(requestStarted());
    softDeleteSubOptionApi(data).then((result) =>{
    dispatch(requestCompleted());
      if(result.success){ 
      dispatch(setSubOptionList(result));
      }else{
        alert(result.message);
      }
    });
  }
}

//addSubOptionBySubQuestion
export const addSubOptionBySubQuestion=(data) =>{
  return dispatch =>{
    dispatch(requestStarted());
    addSubOptionBySubQuestionApi(data).then((result) =>{
    dispatch(requestCompleted());
      if(result.success){
       dispatch(setDemoSubOptionAddSuccess(result));
      }else{
       dispatch(setDemoSubOptionAddFail(result));
      }
    });
  }
}

//getSubOptionDataByOptionId
export const getSubOptionDataByOptionId=(id) =>{
  return dispatch =>{
    dispatch(requestStarted());
    getSubOptionDataByOptionIdApi(id).then((result) =>{
    dispatch(requestCompleted());
      if(result.success){ 
        dispatch(setSubOptionEditData(result));
      }else{
        alert(result.message);
      }
    });
  }
}

//UpdateSubOption

export const UpdateSubOption=(data) =>{
  return dispatch =>{
    dispatch(requestStarted());
    UpdateSubOptionApi(data).then((result) =>{
    dispatch(requestCompleted());
      if(result.success){
       dispatch(setDemographicsSubOptionUpdateSuccess(result));
      }else{
       dispatch(setDemographicsSubOptionUpdateFail(result));
      }
    });
  }
}

//getSecSubQuestionList
export const getSecSubQuestionList=( catId, quesId, subQuesId) =>{
  return dispatch =>{
    dispatch(requestStarted());
    getSecSubQuestionListApi(catId, quesId, subQuesId).then((result) =>{
    dispatch(requestCompleted());
      if(result.success){
       dispatch(setDemographicsCategoriesSecSubQuestions(result));
     }else{
        alert(result.message);
     }
    });
  }
}

//insertSecSubQuestion
export const insertSecSubQuestion=(data) =>{
  return dispatch =>{
    dispatch(requestStarted());
    insertSecSubQuestionApi(data).then((result) =>{
    dispatch(requestCompleted());
      if(result.success){
       dispatch(setDemographicsSecSubQuestionAddSuccess(result));
      }else{
       dispatch(setDemographicsSecSubQuestionAddFail(result));
      }
    });
  }
}

//getSecSubQuesDataById
export const getSecSubQuesDataById=(id) =>{
  return dispatch =>{
    dispatch(requestStarted());
    getSecSubQuesDataByIdApi(id).then((result) =>{
    dispatch(requestCompleted());
      if(result.success){ 
       dispatch(setEditSecSubQuestions(result));
      }else{
        alert(result.message);
      }
    });
  }
}

//updateSecSubQuestion
export const updateSecSubQuestion=(data) =>{
  return dispatch =>{
    dispatch(requestStarted());
    updateSecSubQuestionApi(data).then((result) =>{
    dispatch(requestCompleted());
      if(result.success){
       dispatch(setDemographicsSecSubQuestionUpdateSuccess(result));
      }else{
       dispatch(setDemographicsSecSubQuestionUpdateFail(result));
      }
    });
  }
}

//getSecSubQuesOptionsById
export const getSecSubQuesOptionsById=(id) =>{
  return dispatch =>{
    dispatch(requestStarted());
    getSecSubQuesOptionsByIdApi(id).then((result) =>{
    dispatch(requestCompleted());
      if(result.success){
       dispatch(setSecSubOptionList(result));
      }else{
        alert(result.message);
      }
    });
  }
}

//addSecSubOptionBySubQuestion
export const addSecSubOptionBySubQuestion=(data) =>{
  return dispatch =>{
    dispatch(requestStarted());
    addSecSubOptionBySubQuestionApi(data).then((result) =>{
    dispatch(requestCompleted());
      if(result.success){
       dispatch(setDemoSecSubOptionAddSuccess(result));
      }else{
       dispatch(setDemoSecSubOptionAddFail(result));
      }
    });
  }
}

//softDeleteSecSubOption
export const softDeleteSecSubOption=(data) =>{
  return dispatch =>{
    dispatch(requestStarted());
    softDeleteSecSubOptionApi(data).then((result) =>{
    dispatch(requestCompleted());
      if(result.success){ 
      dispatch(setSecSubOptionList(result));
      }else{
        alert(result.message);
      }
    });
  }
}

//softDeleteSecSubQuestion

export const softDeleteSecSubQuestion=(data) =>{
  return dispatch =>{
    dispatch(requestStarted());
    softDeleteSecSubQuestionApi(data).then((result) =>{
    dispatch(requestCompleted());
      if(result.success){ 
        dispatch(setDemographicsCategoriesSecSubQuestions(result));
      }else{
        alert(result.message);
      }
    });
  }
}

//getSecSubOptionDataByOptionId
export const getSecSubOptionDataByOptionId=(id) =>{
  return dispatch =>{
    dispatch(requestStarted());
    getSecSubOptionDataByOptionIdApi(id).then((result) =>{
    dispatch(requestCompleted());
      if(result.success){ 
        dispatch(setSecSubOptionEditData(result));
      }else{
        alert(result.message);
      }
    });
  }
}

//UpdateSecSubOption
export const UpdateSecSubOption=(data) =>{
  return dispatch =>{
    dispatch(requestStarted());
    UpdateSecSubOptionApi(data).then((result) =>{
    dispatch(requestCompleted());
      if(result.success){
        dispatch(setDemographicsSecSubOptionUpdateSuccess(result));
      }else{
        dispatch(setDemographicsSecSubOptionUpdateFail(result));
      }
    });
  }
}


// WEBPACK FOOTER //
// ./src/actions/demographics.js